import { getConfig } from '@app/config';
import { createQueryParamString, initEmptyItemList } from '@app/utils/util';
import { ItemList, Place } from '@store/domain';
import { derived, get, writable } from 'svelte/store';

/* Store for fetching & storing places (note: fetch only top-level places i.e. towns) */

export const isLoading = writable<boolean>(false);
export const topLevelPlaces = writable<ItemList<Place>>(initEmptyItemList<Place>());

const queryParams = createQueryParamString({
  is_address: 'false',
  no_parent: 'true',
  page_size: '100'
});

export function loadTopLevelPlaces() {
  const { baseUrl } = getConfig().api;
  const { events } = getConfig().modules;
  if (!get(isLoading)) {
    isLoading.set(true);
    console.log('Loading top-level places...');

    const url = `${baseUrl}/${events.apiPath}/place/?${queryParams}`;
    console.log(url);

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        topLevelPlaces.set(res);
        isLoading.set(false);
      })
      .catch((err) => {
        console.error(err);
        isLoading.set(false);
      });
  }
}
